/* eslint-disable react/jsx-no-target-blank */
import { AsideMenuKnowledge } from '../aside-menu-knowledge';
import { AsideMenuMain } from '../aside-menu-main';
import { AsideMenuSales } from '../aside-menu-sales';
import { AsideMenuSettings } from '../aside-menu-settings';
import { ConfigurationTab } from '../components';
import { EmptyTab } from './empty';
import { MenuTab } from './menu-tab';
import { FC } from 'react';

type Props = {
  link: string;
};

const SelectedTab: FC<Props> = ({ link }) => {
  switch (link) {
    case 'projects':
      return (
        <MenuTab>
          <AsideMenuSales />
        </MenuTab>
      );
    case 'menu':
      return (
        <MenuTab>
          {' '}
          <AsideMenuMain />
        </MenuTab>
      );
    case 'subscription':
      return <EmptyTab />;
    case 'tasks':
      return (
        <MenuTab>
          <AsideMenuKnowledge />
        </MenuTab>
      );
    case 'notifications':
      return <EmptyTab />;
    case 'employees':
      return <ConfigurationTab />;
    case 'gear':
      return (
        <MenuTab>
          <AsideMenuSettings />
        </MenuTab>
      );
    default:
      return <EmptyTab />;
  }
};

const TabsBase: FC<Props> = ({ link }) => {
  return (
    <div className="d-flex h-100 flex-column">
      {/* begin::Wrapper */}
      <div
        className="flex-column-fluid hover-scroll-y"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-wrappers="#kt_aside_wordspace"
        data-kt-scroll-dependencies="#kt_aside_secondary_footer"
        data-kt-scroll-offset="0px"
      >
        {/* begin::Tab content */}
        <div className="tab-content">
          <div className="tab-pane fade active show" id={`kt_aside_nav_tab_${link}`} role="tabpanel">
            <SelectedTab link={link} />
          </div>
        </div>
        {/* end::Tab content */}
      </div>
      {/* end::Wrapper */}
      {/* begin::Footer */}
      <div className="flex-column-auto pt-10 px-5" id="kt_aside_secondary_footer"></div>
      {/* end::Footer */}
    </div>
  );
};

export { TabsBase };
